import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay, switchMap } from 'rxjs';
import { LicensesApiService } from './licenses-api.service';
import { BotLicense } from './licenses.abstraction';

@Injectable({
    providedIn: 'root',
})
export class LicensesService {
    #licensesApiService = inject(LicensesApiService);

    #update$ = new BehaviorSubject<void>(void 0);

    isLoading$ = this.#licensesApiService.isLoading$;

    licensesRes$ = this.#update$.pipe(
        switchMap(() => this.#licensesApiService.getLicenses()),
        shareReplay(1),
    );

    licenses$: Observable<BotLicense[]> = this.licensesRes$.pipe(map(res => res.items));

    refresh(): void {
        this.#update$.next();
    }
}
